// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import ReportService from '@services/report'

export const generateReport = createAsyncThunk(
  'reports/generateReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReportService.generateReport(params)
      return {
        params,
        data: response.data || [],
        totalPages: response?.meta?.itemCount ?? (response?.data?.length ?? 0)
      }
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message })
    }
  }
)

const initialState = {
  reportGenerationStatus: '',
  data: [],
  columns: [],
  total: 0,
  params: {},
  loading: false,
  errors: null
}

const Reports = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    resetReport: () => initialState
  },

  extraReducers(builder) {
    builder
      .addCase(generateReport.pending, (state) => {
        state.data = []
        state.columns = []
        state.reportGenerationStatus = ''
        state.loading = true
        state.errors = null
        state.total = 0
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        const rows = action.payload.data || []
        state.data = rows
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
        state.errors = null
        state.reportGenerationStatus =
          rows.length > 0 ? 'Report generated successfully' : 'No result for this query'
        // Columns are built in the component from the row keys; reset here so
        // stale columns from a previous report aren't reused if shape differs.
        state.columns = []
      })
      .addCase(generateReport.rejected, (state, action) => {
        state.loading = false
        state.errors = action.payload
        state.reportGenerationStatus =
          action.payload?.message || 'Failed to generate report. Please try again.'
      })
  }
})

export const { resetReport } = Reports.actions

export default Reports.reducer
